<template>
    <li v-if="!!nextServiceCommunication" data-testId="nextServiceCommunication">
        {{
            $t('coupon.nextApptBookNotif', {
                date: nextServiceCommunicationDate,
                service: nextServiceCommunicationServiceName
            })
        }}
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import { addMinutes } from 'date-fns';
import { formatDatefromJsDate, stringDate } from '@/utils';
import { timezoneUtc } from '@/mixins/timezones-utc/timezone-utc';
import { ConfigurationMessageEnum, ReferenceDateEnum, ServiceSettings } from '@/enums';
import { DateTime } from 'luxon';

export default {
    name: 'coupon-next-appt-book-reminder',
    mixins: [timezoneUtc],
    props: {
        appointment: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getLocale: 'locale',
            getCurrentEstSettings: 'services/getCurrentEstSettings',
            getInstantiatedService: 'services/getInstantiatedService',
            getSelectedServiceConfigurationMessageById: 'services/getSelectedServiceConfigurationMessageById',
        }),

        /**
         * Returns the "Next-Service-To-Book" EST-Configuration-Message Object | Undefined
         */
        nextServiceCommunication() {
            return this.getSelectedServiceConfigurationMessageById(ConfigurationMessageEnum.NEXT_SERVICE_TO_BOOK_FOLLOW_UP);
        },

        /**
         * Return the format date when the next-appt-booking-reminder will be send | Null
         */
        nextServiceCommunicationDate() {
            if (!this.nextServiceCommunication) {
                return null;
            }

            if (this.nextServiceCommunication.referenceDate === ReferenceDateEnum.APPT_CLIENT_BIRTHDAY) {
                let date = DateTime.fromISO(this.appointment.clientData.birthday).setLocale(this.getLocale);

                return this.convertDateTimeToUTC(date).plus({
                    minute: this.nextServiceCommunication.delay,
                }).toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' });
            }

            let date = addMinutes(this.appointment.stop, this.nextServiceCommunication.delay);
            return stringDate(formatDatefromJsDate(date), this.$i18n.locale);
        },

        /**
         * Returns the "Next-Service-To-Book" EST-Setting Object | Null | Undefined
         */
        nextServiceCommunicationSetting() {
            if (!this.nextServiceCommunication) {
                return null;
            }

            return find(this.getCurrentEstSettings, {
                setting: ServiceSettings.NEXT_SERVICE_TO_BOOK,
            });
        },

        /**
         * Returns the "Next" Service Object | Null | Undefined
         */
        nextServiceCommunicationService() {
            if(!this.nextServiceCommunication || !this.nextServiceCommunicationSetting) {
                return null;
            }
            return this.getInstantiatedService(this.nextServiceCommunicationSetting.value);
        },

        /**
         * Returns the "Next" Service Name based on locale | empty string
         */
        nextServiceCommunicationServiceName() {
            return this.nextServiceCommunicationService
                ? this.nextServiceCommunicationService[`name${this.upperLocale}`]
                : '';
        },
    },
};
</script>
